import { motion } from "framer-motion";

const NotFound = () => {
  return (
    <motion.div 
      className="flex flex-col items-center justify-center h-screen"
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.h1 
        className="text-4xl font-bold text-green-600"
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.3 }}
      >
        404 - Page Not Found
      </motion.h1>
      <motion.p 
        className="mt-2 text-gray-600"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.5 }}
      >
        Oops! The page you are looking for does not exist.
      </motion.p>
    </motion.div>
  );
};

export default NotFound;
